import nodeClient from "./node-client";

export const getConfig = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/configuration/get?${encodeURI(query)}`
  );
  return response.data.result;
};

export const saveConfig = async (formData) => {
  const response = await nodeClient.post(
    `/service/private/v0/configuration/mapping/save`,
    formData
  );
  return response.data;
};

export const getConfigLabel = async () => {
  const response = await nodeClient.get(
    `/service/private/v0/configuration/get/constants`
  );
  return response.data.result;
};
